// extracted by mini-css-extract-plugin
export default {"icon":"jEpIr","text":"_2aDrS","button":"v7pK9","textButton":"Ks8J0","iconButton":"pL99v","animated":"Bd+mu","verticalAlign":"Ruyaf"};